/**
 * @description : common config file for api endpoint.
 * @author : Bhargav Lakhani
 * @since : 17 Dec 2021
 */

// export const API_URL = 'https://api.resq-app.com';
export const API_URL = 'https://api-stage.resq-app.com';

// export const API_URL = process.env.REACT_APP_API;